import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
//import React, { useState }  from "react";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
// Images
import { FIND_ORGANS_BY_MUNICIPALITY } from "queries";
import { useQuery } from "@apollo/client";
import { useLazyQuery } from "@apollo/client";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import bgImage from "assets/images/strategia.jpg";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
/* eslint-disable react/prop-types */

/*const organsw = useQuery(ALL_ORGANS, {
  pollInterval: 100000,
});
*/
const Organs = ({ selectedKunta, setSelectedKunta }) => {
  ////console.log(BY_MUNICIPALITY_ORGANS);
  //const [organs, setOrgans] = useState([]);
  const shareUrl = "https://kunta.live/organs/select/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  let muni = useParams().municipality;
  useEffect(() => {
    if (muni !== undefined) {
      setSelectedKunta(muni);
    }
  }, [muni]);
  // eslint-disable-next-line
  const [getOrgan, result] = useLazyQuery(FIND_ORGANS_BY_MUNICIPALITY);
  const [organs, setOrgans] = useState([]);
  const [t] = useTranslation("common");
  //console.log(getOrgan);
  //console.log(result);
  //console.log(selectedKunta);
  ////console.log(setOrgans);
  const organsw = useQuery(FIND_ORGANS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { organmunicipality: selectedKunta },
  });
  useEffect(() => {
    let organss = [];
    //let municipalitiess = [];
    if (organsw.data) {
      //console.log(organsw.data);
      organss = organsw.data.findOrgansByMunicipality;
      //setOrgans(organss);
      //console.log(organss);
      setOrgans(organss);
      //municipalitiess=organsw.data.allOrgans
    }
  }, [selectedKunta, organsw]);
  // eslint-disable-next-line
  //const [getOrgan, result] = useLazyQuery(FIND_ORGAN);
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [organs, setorgans] = useState([]);
  /*const organsw = useQuery(BY_MUNICIPALITY_ORGANS, {
    variables: { organmunicipality:selectedKunta },
    pollInterval: 10000
  });
  
  let organss=[]
  if(organsw.data){
    organss=organsw.data.findOrgans
  //console.log(organss)
  }
  */
  //console.log(selectedKunta);
  //console.log(setSelectedKunta);
  //useEffect(() => {
  //if (organsw.data) {
  //setOrgans(organsw.data.allOrgans);
  ////console.log(organss);
  //municipalitiess=organsw.data.allOrgans
  //}
  //}, []);
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {t("headers.organs")}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {organs.map((p) => (
                <Button
                  key={p.organname}
                  variant="contained"
                  size="normal"
                  color="inherit"
                  component={Link}
                  to={`/meetings/organ/${p.organname}`}
                >
                  {p.organname}
                </Button>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Organs;
